import { DatePipe } from '@angular/common';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { constObj } from 'src/app/common/Constants/constants';
import { OpenLeftNavLinkService } from 'src/app/common/services/open-left-nav-link.service';
import { ConfirmDialogComponent } from 'src/app/common/shared-components/confirm-dialog/confirm-dialog.component';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-master-glossary',
  templateUrl: './master-glossary.component.html',
  styleUrls: ['./master-glossary.component.css']
})
export class MasterGlossaryComponent implements OnInit, AfterViewChecked {

  contacts: any = [];
  contactsOnAlphaClick: any = [];

  result: any;
  alphabetsArray: any[][];
  alphabetArray: string[];
  filter: string = "";
  originalDataSet: any;
  selectedAlphabet: string = "";
  apiResponse: any;
  title: string = "";
  body: any = "";
  outcome: boolean = false;
  showNoResults: boolean;
  PageCount: number = 0;
  NextPageData: any;
  availableAlphabets = [];
  along_with_filter: string = "";
  constructor(
    private graphQlService: GraphqlService,
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private domSanitizer: DomSanitizer,
    private openleftnavlink: OpenLeftNavLinkService,
    private route: Router,
    private session: SessionService,
    private datePipe: DatePipe,
    public dialog: MatDialog) {
    this.alphabetsArray = [["0-9", "A", "B", "C"], ["D", "E", "F", "G"], ["H", "I", "J", "K"], ["L", "M", "N", "O"], ["P", "Q", "R", "S"], ["T", "U", "V", "W"], ["X", "Y", "Z"]]
    this.alphabetArray = ["0-9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
  }
  private glossaryterm$ = new Subject<string>();
  secDefinition = constObj.secDefinition;
  ngOnInit() {
    this.glossaryterm$.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      this.onChangeText();
      this.getGlossaryContent();
    });
    this.commonDataService.showLoader.next(true);
    this.graphQlService.getGlobalLabels().subscribe(globalLabels => {
      this.getAlphabetsList();
      this.getGlossaryLabel(globalLabels);
      if (!this.LoadMasterGlossaryFromContentPageBackButton()) {
        this.getGlossaryContent();
      }
      this.outcome = true;
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  ngAfterViewChecked() {
    let filter = sessionStorage.getItem("glossaryUsageGlossaryFilter");
      if (!(filter === "undefined" || filter === null)) {
        this.PageCount = 0;
        this.commonDataService.showLoader.next(true);
        let spanA = document.createElement("span");
        spanA.innerHTML = filter;
        this.filter = spanA.innerText.trim().toLowerCase();
        this.getGlossaryContent(); sessionStorage.removeItem("glossaryUsageGlossaryFilter");
    }
  }

  // ngAfterViewInit(): void {
  //   this.showRightOverlay = true;
  // }
  ngAfterContentChecked() {
    this.EnableBackToTop();
    var mainBodyShowSource = document.getElementsByClassName("sfragment-mainBody-ShowSource") as HTMLCollectionOf<HTMLElement>;
    var ShowSource = document.getElementsByClassName("sfragment-showSource") as HTMLCollectionOf<HTMLElement>;
    this.commonDataService.glossaryShowSource.subscribe(showSource => {
      if (showSource) {
        if (ShowSource.length > 0) {
          for (let i = 0; i < ShowSource.length; i++) {
            // ShowSource[i].className = ShowSource[i].className + " display-none";
            ShowSource[i].className = ShowSource[i].className.replace(/display-none/g, "");
            ShowSource[i].className = ShowSource[i].className + " sfragment-glossary-showSource";
          }
        }
        if (mainBodyShowSource.length > 0) {
          for (let j = 0; j < mainBodyShowSource.length; j++) {
            mainBodyShowSource[j].className = mainBodyShowSource[j].className + " sfragment-glossary-mainBody-ShowSource";
          }
        }
        //this.DisplaySource= this.DisplaySource=="Show Source"?"Hide Source":"Show Source";
      }
      else {
        if (ShowSource.length > 0) {
          for (let i = 0; i < ShowSource.length; i++) {
            ShowSource[i].className = ShowSource[i].className.replace(/sfragment-glossary-showSource/g, "");
            ShowSource[i].className = ShowSource[i].className + "  display-none";
          }
        }
        if (mainBodyShowSource.length > 0) {
          for (let j = 0; j < mainBodyShowSource.length; j++) {
            mainBodyShowSource[j].className = mainBodyShowSource[j].className.replace(/sfragment-glossary-mainBody-ShowSource/g, "");
          }
        }
        //this.DisplaySource= this.DisplaySource=="Show Source"?"Hide Source":"Show Source";
      }
    })
  }

  LoadMasterGlossaryFromContentPageBackButton() {
    var isButtonClicked = this.commonDataService.glossaryTermBackButtonClicked.getValue();
    if (isButtonClicked) {
      // this.filter=this.commonDataService.glossaryTerm.getValue();
      // this.selectedAlphabet=this.filter.substring(0,1).toUpperCase();
      // if(Number(this.selectedAlphabet)){
      //   this.selectedAlphabet="0-9";
      // }
      // this.commonDataService.glossaryTerm.next("");
      this.commonDataService.glossaryTermBackButtonClicked.next(false);
      this.getGlossaryContent();
    }

    return isButtonClicked;
  }
  masterGlossaryHeader: string = "";
  FilterLabel: string = "";
  PlaceholderLabel: string = "";
  noFoundHeader: string = "";
  noFoundDescription: string = "";
  resetButton: string = "";
  glossaryTermUsage: string = "";
  seeTopics: string = "";
  btn_loadmore;
  // showRightOverlay: boolean = false;

  getGlossaryLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.masterGlossaryHeader = labels.filter(x => x.key == "glossary_header").map(y => y.value);
      this.FilterLabel = labels.filter(x => x.key == "glossary_filter").map(y => y.value);
      this.PlaceholderLabel = labels.filter(x => x.key == "glossary_enterTerm").map(y => y.value);
      this.noFoundHeader = labels.filter(x => x.key == "glossary_noResultFound").map(y => y.value);
      this.noFoundDescription = labels.filter(x => x.key == "glossary_noResultFoundMessage").map(y => y.value);
      this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
      this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
      this.resetButton = labels.filter(x => x.key == "glossary_Reset").map(y => y.value);
      this.along_with_filter = labels.filter(x => x.key == "global_alongWith").map(y => y.value);
      this.btn_loadmore = labels.filter(x => x.key == "btn_loadmore").map(y => y.value);

    }
  }
  availableAlphabetsList: any = [];
  tempavailableAlphabetsList: any = [];
  getAlphabetsList() {
    if (this.filter == "") {
      this.graphQlService.GetGlossaryAlphabetList().subscribe(alphabetsList => {
        this.availableAlphabets = this.setAlphabetList(alphabetsList.aggregations);
        this.tempavailableAlphabetsList = this.availableAlphabets;
      })
    }
  }
  setAlphabetList(aggregation) {
    this.availableAlphabets = [];
    if (aggregation.a_Count.docCount > 0) { this.availableAlphabets.push("A") }
    if (aggregation.b_Count.docCount > 0) { this.availableAlphabets.push("B") }
    if (aggregation.c_Count.docCount > 0) { this.availableAlphabets.push("C") }
    if (aggregation.d_Count.docCount > 0) { this.availableAlphabets.push("D") }
    if (aggregation.e_Count.docCount > 0) { this.availableAlphabets.push("E") }
    if (aggregation.f_Count.docCount > 0) { this.availableAlphabets.push("F") }
    if (aggregation.g_Count.docCount > 0) { this.availableAlphabets.push("G") }
    if (aggregation.h_Count.docCount > 0) { this.availableAlphabets.push("H") }
    if (aggregation.i_Count.docCount > 0) { this.availableAlphabets.push("I") }
    if (aggregation.j_Count.docCount > 0) { this.availableAlphabets.push("J") }
    if (aggregation.k_Count.docCount > 0) { this.availableAlphabets.push("K") }
    if (aggregation.l_Count.docCount > 0) { this.availableAlphabets.push("L") }
    if (aggregation.m_Count.docCount > 0) { this.availableAlphabets.push("M") }
    if (aggregation.n_Count.docCount > 0) { this.availableAlphabets.push("N") }
    if (aggregation.o_Count.docCount > 0) { this.availableAlphabets.push("O") }
    if (aggregation.p_Count.docCount > 0) { this.availableAlphabets.push("P") }
    if (aggregation.q_Count.docCount > 0) { this.availableAlphabets.push("Q") }
    if (aggregation.r_Count.docCount > 0) { this.availableAlphabets.push("R") }
    if (aggregation.s_Count.docCount > 0) { this.availableAlphabets.push("S") }
    if (aggregation.t_Count.docCount > 0) { this.availableAlphabets.push("T") }
    if (aggregation.u_Count.docCount > 0) { this.availableAlphabets.push("U") }
    if (aggregation.v_Count.docCount > 0) { this.availableAlphabets.push("V") }
    if (aggregation.w_Count.docCount > 0) { this.availableAlphabets.push("W") }
    if (aggregation.x_Count.docCount > 0) { this.availableAlphabets.push("X") }
    if (aggregation.y_Count.docCount > 0) { this.availableAlphabets.push("Y") }
    if (aggregation.z_Count.docCount > 0) { this.availableAlphabets.push("Z") }
    if (aggregation.number0_Count?.docCount > 0 || aggregation.number1_Count?.docCount > 0 || aggregation.number2_Count?.docCount > 0 || aggregation.number3_Count?.docCount > 0 || aggregation.number4_Count?.docCount > 0 || aggregation.number5_Count?.docCount > 0 || aggregation.number6_Count?.docCount > 0 || aggregation.number7_Count?.docCount > 0 || aggregation.number8_Count?.docCount > 0 || aggregation.number9_Count?.docCount > 0) { this.availableAlphabets.push("0-9") }
    return this.availableAlphabets;
  }

  totalCount: number = 0;
  getGlossaryContent() {
    var searchTerm = this.commonDataService.glossaryTerm.getValue();
    this.totalCount = 0;
    if (this.PageCount == 0) {
      this.resultCount = 0;
    }
    if (searchTerm != "") {
      let spanA = document.createElement("span");
      spanA.innerHTML = searchTerm;
      this.filter = spanA.innerText.trim().toLowerCase();
      this.selectedAlphabet = searchTerm.substring(0, 1).toUpperCase();
      if (Number(this.selectedAlphabet)) {
        this.selectedAlphabet = "0-9";
      }
      this.commonDataService.glossaryTerm.next("");
    }
    if (this.filter != "") {
      this.graphQlService.GetMasterGLossaryAlphabetsfiltered(this.filter).subscribe(alphabetsList => { this.availableAlphabets = this.setAlphabetList(alphabetsList.aggregations); })
    }
    else {
      this.getAlphabetsList()
    }

    this.graphQlService.GetGlossaryContent(this.filter, this.selectedAlphabet, this.PageCount).subscribe(glossaryContent => {
      this.contacts = [];
      this.originalDataSet = [];
      this.totalCount = glossaryContent?.hits?.total?.value;
      this.showNoResults = (this.totalCount == 0) ? true : false;
      this.mapGlossaryContent(glossaryContent?.hits?.hitsList);
      this.outcome = true;
    });
  }
  topic: any = [];
  distinctTopics: any = [];
  resultCount: number = 0;
  mapGlossaryContent(data) {
    let sorter = this.MySort(" '-_()0123456789abcdefghijklmnopqrstuvwxyz");
    if (data) {
      this.apiResponse = data;
      this.apiResponse.forEach(res => {
        this.topic = [];
        this.distinctTopics = [];
        let source = res.source;
        this.title = source.title;

        if (source.body.includes("pending-text")) {
          source.body = this.addPendingContent(source.body);
        }
        this.body = this.domSanitizer.bypassSecurityTrustHtml(source.body);
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.topic.push(usage)
          });
        }
        var count = 0;
        if (this.topic.length > 0) {
          this.topic.forEach(topicRes => {
            if (topicRes.topic != null && topicRes.topic != undefined) {
              if (count == 0) {
                let obj = {
                  topic: topicRes.topic,
                  topicData: [topicRes]
                }
                this.distinctTopics.push(obj);
                count++;
              }
              else {
                var topics = this.distinctTopics.filter(x => x.topic == topicRes.topic);
                if (topics.length > 0) {
                  this.distinctTopics.filter(x => x.topic == topicRes.topic)[0].topicData.push(topicRes);
                }
                else {
                  let obj = {
                    topic: topicRes.topic,
                    topicData: [topicRes]
                  }
                  this.distinctTopics.push(obj);
                }
                count++;
              }
            }
          })
        }
        this.distinctTopics = this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.topic = this.topic.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        var content = {};
        if (this.contacts?.filter(x => x.name == this.title).length >= 1) {
          var multipleDef = { name: this.title, capital: this.body, sortOrder: source.sortOrder, topic: this.topic, seetopic: this.distinctTopics, type: source.glossaryType };
          this.contacts.find(x => x.name == this.title).multipleDefinitions.push(multipleDef);
          this.contacts.find(x => x.name == this.title).multipleDefinitions.sort(sorter)
          this.contacts.find(x => x.name == this.title).multipleDefinitions.sort((a, b) => (a.sortOrder < b.sortOrder) ? -1 : 1);
        }
        else {
          content = { name: this.title, multipleDefinitions: [{ name: this.title, capital: this.body, sortOrder: source.sortOrder, topic: this.topic, seetopic: this.distinctTopics, type: source.glossaryType }] };
          //if(this.title!=null && this.title!=undefined){
          this.contacts.push(content);
          //}
        }
      });
      if (this.contacts != null) {
        this.contacts.sort(sorter);
      }
     
      this.originalDataSet = this.contacts;
      if (this.PageCount == 0) {
        this.result = this.createResultFromContact(this.contacts);
      }
      else {
        this.NextPageData = this.createResultFromContact(this.contacts);
        if (this.NextPageData.length != 0) {
          this.NextPageData.forEach(NewData => {
            var concatContact = this.result.find(x => x.key == NewData.key);
            if (concatContact) {
              this.result.find(x => x.key == NewData.key).contacts = concatContact.contacts.concat(NewData.contacts);
            }
            else {
              this.result.push(NewData)
            }
          });
        }
      }
      this.result.sort((a, b) => (a.key.toLowerCase() < b.key.toLowerCase() ? -1 : 1));
      this.result.forEach(res => {
        res.contacts = res.contacts.sort(sorter)
      });
      this.resultCount = this.resultCount + this.apiResponse.length;

    }
  }


  MySort(alphabet) {
    return function (a, b) {
      var pos1 = 0;
      var pos2 = 0;
      for (var i = 0; i < Math.min(a.name.length, b.name.length) && pos1 == pos2; i++) {
        pos1 = alphabet.indexOf(a.name[i].toLowerCase());
        pos2 = alphabet.indexOf(b.name[i].toLowerCase());
      }

      if (pos1 == pos2 && a.name.length != b.name.length) {
        return a.name.length - b.name.length;
      }

      return pos1 - pos2;
    };
  }

  addPendingContent(body) {
    if (body != null && body.includes("pending-text")) {
      var doc = new DOMParser().parseFromString(body, "text/html");
      let ImageDivs = doc.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
      for (let i = 0; i < ImageDivs.length; i++) {
        let normText = doc.getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;

        if (normText.length == 0) {
          ImageDivs[i].className += " mt-0";
        }
        let pending_content_text_div = doc.getElementsByClassName("pending-question-icon") as HTMLCollectionOf<HTMLElement>;
        if (pending_content_text_div != null && pending_content_text_div.length == 0) {
          let divBlock = document.createElement("div");
          divBlock.setAttribute("id", "pending-content-text")
          let img = document.createElement("img");
          img.src = "../../../../assets/icons/clock-black.svg";
          img.alt = "Clock Image";
          img.className = "pending-clock-icon"
          let imgQuestion = document.createElement("img");
          imgQuestion.src = "../../../../assets/icons/Help.svg";
          imgQuestion.alt = "Question Image";
          imgQuestion.className = "pending-question-icon";
          let textBlock = document.createElement("span");
          textBlock.innerText = "PENDING CONTENT";
          textBlock.className = "mat-Info";
          divBlock.appendChild(img);
          divBlock.appendChild(textBlock);
          divBlock.appendChild(imgQuestion);
          divBlock.className = "bottomMargin";
          ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
        }

        let dateSection = doc.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

        if (dateSection.length > 0) {
          for (let j = 0; j < dateSection.length; j++) {
            let divBlock1 = document.createElement("div");
            divBlock1.className = "mt-1rem";
            dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

            let guidanceLink = dateSection[j].nextElementSibling;
            if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
              guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
            }
          }
        }
      }
      body = doc.documentElement.innerHTML;
      return body;
    }
  }

  goLetter(alphabet: string) {
    this.PageCount = 0;
    // this.showNoResults = true;
    this.commonDataService.showLoader.next(true);
    this.selectedAlphabet = alphabet;
    this.getGlossaryContent();
  }

  IsSearchTermEmpty() {
    return this.filter == "" ? true : false;
  }

  IsSelectedAlphabet(alphabet: string) {
    return this.selectedAlphabet == alphabet ? true : false;
  }

  onChangeText() {
    this.PageCount = 0;
    this.glossaryterm$.next(this.filter)
  }

  createResultFromContact(passedContacts) {
    const grouped = passedContacts.reduce((groups, contact) => {
      if (contact?.name?.charCodeAt(0) >= 48 && contact?.name?.charCodeAt(0) <= 57) {
        groups["0-9"] = groups["0-9"] || [];
        groups["0-9"].push(contact);
      }
      else {
        const letter = contact?.name?.charAt(0).toLocaleUpperCase();
        groups[letter] = groups[letter] || [];
        groups[letter].push(contact);
      }
      return groups;
    }, {});
    this.commonDataService.showLoader.next(false);
    return Object.keys(grouped).map(key => ({ key, contacts: grouped[key] }));
  }
  resetSearchText() {
    this.commonDataService.showLoader.next(true);
    this.filter = "";
    this.selectedAlphabet = "";
    this.contacts = [];
    this.PageCount = 0;
    this.result = [];
    this.getGlossaryContent();
  }

  loadNextPage() {
    this.PageCount = this.PageCount + 1;
    this.getGlossaryContent();
  }

  ViewAll() {
    this.contacts = [];
    this.filter = "";
    this.selectedAlphabet = "";
    this.PageCount = 0;
    this.getGlossaryContent();
  }
  setFocus() {
    document.getElementById("glossaryPage").scroll(0, 0);
  }

  enableBackToTop: boolean = false;

  EnableBackToTop() {
    var div = document.getElementById("glossaryPage");
    // var div = document.getElementById("scrollList");
    if (div != null) {
      var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

      if (hasVerticalScrollbar) {
        this.enableBackToTop = true;
      }
      else {
        this.enableBackToTop = false;
      }
    }
  }
  OpenLink(event, glossaryTitle: string) {
    const path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && (p.className == "xref" || p.className == "l xref"));
    var searchTerm = event.target.innerText;
    var dataLink = event.target.dataset.link;
    //if (searchTerm.toLocaleLowerCase().includes(("accounting standards update").toLocaleLowerCase())) {
    //  this.graphQlService.getGASBLink().subscribe(data => {
    //    let FASBPath: string = "<a href='" + data + "' target='blank' class='dialog highlight-blue border-bottom-help cursor-pointer singleLine'>" + data + "</a>";
    //    this.commonDataService.CrossRefReportNotGenerated.next(false);
    //    this.commonDataService.isConfirmationPopUpOpen.next(true);
    //    this.dialog.open(ConfirmDialogComponent, {
    //      disableClose: true,
    //      width: '600px',
    //      data: constObj.notAvailableForBAsic + FASBPath
    //    });
    //  }, err => {
    //    console.log(err);
    //    this.commonDataService.showLoader.next(false);
    //  });
    //}
    //else {
      if (xref && isNaN(Number(searchTerm.split("-")[0])) && !searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
        let href = xref.getAttribute('href').split("/");
        let guid = xref.getAttribute('href').includes('#') ? xref.getAttribute('href').split('#')[1] : href[href.length - 1];
        this.commonDataService.glossaryTermId.next(guid);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("inline-glossary");
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      }
      else if (dataLink == "contentPage" || event.target.className.includes("ditamap")) {
        this.commonDataService.glossaryTermFromContentPageBackButton.next(glossaryTitle);
        this.openleftnavlink.GetLeftNavLink(event);
      }
      else if (dataLink == undefined && dataLink == null && (!isNaN(Number(searchTerm.split("-")[0])) || searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())) || searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
        let href = xref.getAttribute('href');
        let UrlParts = href.split("/");
        if (searchTerm.includes("(")) {
          searchTerm = searchTerm.split("(")[0];
        }
        if (searchTerm.includes("[")) {
          searchTerm = searchTerm.split("[")[0];
        }
        if (searchTerm.includes("to")) {
          searchTerm = searchTerm.split(" to")[0];
        }
        if (searchTerm.includes("through")) {
          searchTerm = searchTerm.split(" through")[0];
        }
        let url = !isNaN(Number(searchTerm.split("-")[0])) ? this.getBreadcrumbWithNavPath(searchTerm.split("-")[0] + "-" + searchTerm.split("-")[1] + "-" + searchTerm.split("-")[2] )+ "/" + searchTerm : "/" + UrlParts[1] + "/" + UrlParts[2];
        this.commonDataService.glossaryTermFromContentPageBackButton.next(glossaryTitle);
        this.route.navigateByUrl(url);
      }
    /*}*/
  }

  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !ahref.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
        return false;
      }
      else if (ahref.includes("-")) {
        event.srcElement.setAttribute("href", this.getBreadcrumbWithNavPath(ahref.split("-")[0] + "-" + ahref.split("-")[1] + "-" + ahref.split("-")[2]) + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
  }

  navPathTreeCall$: Subscription;
  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          let navPathUrl: string = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + ahref);
        }
        else {
          this.navPathTreeCall$ = this.graphQlService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
        }
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    for (let i = 0; i < 9; i++) {
      let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }
}
